import React, { createContext, useContext, useState } from "react";
import { toast } from "sonner";
import { router } from "@inertiajs/react";

const WishlistContext = createContext<any>(null);

export const WishlistProvider = ({ children }: any) => {

    const [wishlist, setWishlist] = useState<number[]>([]);

    const toggleWishlist = (productId: number) => {

        router.post('/wishlist/toggle', { product_id: productId }, {
            preserveScroll: true,
            onSuccess: (page: any) => {
                if (page.props.flash.success === 'Product added to wishlist') {
                    setWishlist((prev) => [...prev, productId]);
                    toast.success(page.props.flash.success);
                } else {
                    setWishlist((prev) => prev.filter(id => id !== productId));
                    toast.error(page.props.flash.success);
                }
            }
        });
    };

    const isWishlisted = (productId: number) => {
        return wishlist.includes(productId);
    };

    return (
        <WishlistContext.Provider
            value={{
                wishlist,
                toggleWishlist,
                isWishlisted
            }}
        >
            {children}
        </WishlistContext.Provider>
    );
};

export const useWishlist = () => useContext(WishlistContext);